module.exports = __webpack_public_path__ + "img/CICOS.a0b75263.jpg";